import React from 'react'
import {translate} from 'react-i18next'

import ButtonIcon from './ButtonIcon'
import ButtonText from './ButtonText'
import ButtonView from './ButtonView'
import ButtonDescription from './ButtonDescription'
import ButtonChildrenWrapper from './ButtonChildrenWrapper'
import ButtonSpinnerDot from './ButtonSpinnerDot'
import theme from 'theme'
import {getBrandComponents} from 'theme/components'
import {useLoadingClick} from 'hooks'

const Button = ({
  t,
  label,
  description,
  children,
  onClick,
  className,
  color,
  hoverColor,
  focusColor,
  activeColor,
  background,
  hoverBackground,
  focusBackground,
  activeBackground,
  portraitWidth,
  border,
  hoverBorder,
  focusBoxShadow,
  activeBoxShadow,
  focusBorder,
  activeBorder,
  icon,
  hoverIcon,
  activeIcon,
  iconStyles,
  textStyles = {},
  descriptionStyles = {},
  disabled,
  full,
  type,
  autoFocus,
  small,
  id,
  isAnimated,
  loading,
  dotsColor,
}) => {
  const {handleOnClick, isLoading} = useLoadingClick({onClick})
  const View = getBrandComponents(theme.brand.name).ButtonView || ButtonView
  const Text = getBrandComponents(theme.brand.name).ButtonText || ButtonText

  return (
    <View
      id={id}
      onClick={handleOnClick}
      disabled={disabled}
      className={className}
      color={color}
      type={type}
      autoFocus={autoFocus}
      hoverColor={hoverColor}
      activeColor={activeColor}
      focusColor={focusColor}
      border={border}
      portraitWidth={portraitWidth}
      hoverBorder={hoverBorder}
      activeBorder={activeBorder}
      focusBorder={focusBorder}
      background={background}
      hoverBackground={hoverBackground}
      focusBackground={focusBackground}
      focusBoxShadow={focusBoxShadow}
      activeBoxShadow={activeBoxShadow}
      activeBackground={activeBackground}
      full={full}
      isAnimated={isAnimated}
      small={small}
      height={description && '50px'}>
      <ButtonChildrenWrapper>
        {icon && (
          <ButtonIcon color={color} icon={icon} hoverIcon={hoverIcon} activeIcon={activeIcon} styles={iconStyles} />
        )}
        {loading || isLoading ? (
          <ButtonSpinnerDot dotsColor={dotsColor} />
        ) : (
          <Text icon={icon} styles={textStyles}>
            {t(label || children)}
            {description && <ButtonDescription styles={descriptionStyles}>{t(description)}</ButtonDescription>}
          </Text>
        )}
      </ButtonChildrenWrapper>
    </View>
  )
}

export {Button as PureButton}

export default translate()(Button)
